import { render, staticRenderFns } from "./EngMainRealtimeDibs.vue?vue&type=template&id=c113dc68&"
import script from "./EngMainRealtimeDibs.vue?vue&type=script&lang=js&"
export * from "./EngMainRealtimeDibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports